export const googleFormUrls = {
  // 契約を報告するためのフォーム（ワーカー用）
  formForReportingContractForWorker:
    "https://docs.google.com/forms/d/e/1FAIpQLSc1NYhoKevF2htmwNxR0tVxPiUSH05Yg595DZCvdnklnioA2A/viewform?usp=sf_link",
  // 契約を報告するためのフォーム（企業用用）
  formForReportingContractForCorporation:
    "https://docs.google.com/forms/d/e/1FAIpQLSeN9xxm_Xnlj6oRfCLbrSShveyzCTY5TNa50LdCC_E67JSk5g/viewform?usp=sf_link",
}

export const mediaUrls = {
  crowdLinksMedia: "https://note.com/crowdlinks/",
}

export const swUrl = {
  privacyPolicy: "https://company.shuuumatu-worker.jp/privacy/",
}
